var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('introduce-page',[_c('div',{staticStyle:{"margin-left":"15%","width":"60%"}},_vm._l((_vm.imgList),function(img,i){return _c('el-row',{key:i,staticStyle:{"width":"100%"}},[_c('el-row',{staticStyle:{"margin-top":"20px","margin-bottom":"16px","width":"100%"}},[_c('el-image',{staticStyle:{"width":"100%"},attrs:{"src":img}})],1)],1)}),1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2d7044c9","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/introduce/CompanyCulture.vue
// module id = null
// module chunks = 